<template>
    <div class="modal fade" id="cotizacion_propuesta">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Cotización de tu usado!</h4>
                </div>
                <div class="modal-body">
                    <b-card>
                        <b-row>
                            <b-col md="12" class="text-center mb-2">
                                <div>
                                    <h4 class="m-0">
                                        <i class="fa fa-car"></i>
                                        {{usadoData.marca}}
                                        {{usadoData.linea}}
                                        {{usadoData.modelo}}
                                    </h4>
                                    <h5 class="grey-text">
                                        {{usadoData.version}} | {{formatPrice(usadoData.kilometraje)}} km
                                    </h5>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card>
                    <div class="col-12 table-responsive mt-2">
                        <table class="table table-striped table-bordered">
                            <tbody>
                                <tr>
                                    <td>Publicación</td>
                                    <td>
                                        $
                                        {{
                                            numberWithCommas(
                                                cotizacionData.vr_publicacion
                                            )
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Sugerido</td>
                                    <td>
                                        $
                                        {{
                                            numberWithCommas(
                                                cotizacionData.vr_sugerido
                                            )
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Mínimo</td>
                                    <td>
                                        $
                                        {{
                                            numberWithCommas(
                                                cotizacionData.vr_minimo
                                            )
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Retoma</td>
                                    <td>
                                        $
                                        {{
                                            numberWithCommas(
                                                cotizacionData.vr_retoma
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mainHelper from 'helpers/main-helper'
export default {
    computed: {
        cotizacionData() {
            return this.$store.state.propuesta.cotizacion;
        },
        usadoData() {
            return this.$store.state.propuesta.vehiculo_usado;
        }
    },
    methods: {
        numberWithCommas(stringReal) {
            var toInt = parseInt(stringReal);
            var roundedValue = Math.round(toInt / 100000) * 100000;
            return roundedValue
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        formatPrice(number){
            return mainHelper.numberWithDotsNotRounded(number);
        }
    }
};
</script>

<style lang="scss">
h5.text-red {
    color: #fa2837;
}
</style>
